import { render, staticRenderFns } from "./allarea.vue?vue&type=template&id=bd08c6d6&scoped=true&"
import script from "./allarea.vue?vue&type=script&lang=js&"
export * from "./allarea.vue?vue&type=script&lang=js&"
import style0 from "./allarea.vue?vue&type=style&index=0&id=bd08c6d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd08c6d6",
  null
  
)

export default component.exports